import { motion } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon.js";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro.js";
import LoadingBar from "../../../../components/LoadingBar/LoadingBar";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalCadastro from "../../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import NewIcon from "../../../../components/NewIcon/NewIcon";
import SelectEmbarqueV2 from "../../../../components/SelectEmbarqueV2/SelectEmbarqueV2";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao.js";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2.js";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import CoresRedux from "../../../../contexts/Cor.js";
import NomeTabelaRedux from "../../../../contexts/NomeTabela.js";
import RequestControllerRedux from "../../../../contexts/RequestController.js";
import TabelaRedux from "../../../../contexts/Tabela.js";
import DadosUsuarioRedux from "../../../../contexts/Usuario.js";
import { getRegras } from "../../../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraSubTipoOcorrencia,
	deleteSubTipoOcorrenciaPorId,
	editaSubTipoOcorrenciaPorId,
	getSubTipoOcorrencia,
	getSubTipoOcorrenciaPorId,
} from "../../../../services/ModuloGerenciador/SubTipoOcorrencia.js";
import { getTipoOcorrencia } from "../../../../services/ModuloGerenciador/TipoOcorrencia.js";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario.js";
import "./SubTipoOcorrencia.css";

function SubTipoOcorrencia(props) {
	const { dadosCoresRedux } = useContext(CoresRedux);

	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const preencherDadosEditando = async (result) => {
		const tipoOcorrenciaSelecionado = listaTipoOcorrencia.find(
			(option) => option.idTipoOcorrencia === result.data.tipoOcorrenciaId
		);
		if (tipoOcorrenciaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				tipoOcorrencia: {
					value: tipoOcorrenciaSelecionado.nome,
					label: tipoOcorrenciaSelecionado.nome,
					id: tipoOcorrenciaSelecionado.idTipoOcorrencia,
				},
			}));
		}
	};

	const buscarSubTipoOcorrencia = async () => {
		setLoading(true);
		await getSubTipoOcorrencia(dadosUsuarioRedux.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (values.nome !== "" && validator.nome === "true") {
			setLoading(true);
			await cadastraSubTipoOcorrencia(values, dadosUsuarioRedux.token)
				.then((result) => {
					if (result.status === 200) {
						buscarSubTipoOcorrencia();
						setDadosRequestControllerRedux("Fechar Modal SubTipoOcorrencia");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaSubTipoOcorrenciaPorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarSubTipoOcorrencia();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarSubTipoOcorrenciaPorId = async () => {
		setLoading(true);
		await getSubTipoOcorrenciaPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await preencherDadosEditando(result);
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarSubTipoOcorrenciaPorIdModal = async (id) => {
		setLoading(true);
		await getSubTipoOcorrenciaPorId(id, dadosUsuarioRedux.token)
			.then(async (result) => {
				if (result.status === 200) {
					await preencherDadosEditando(result);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarSubTipoOcorrenciaPorId = async () => {
		setLoading(true);
		await deleteSubTipoOcorrenciaPorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarSubTipoOcorrencia();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Sub Tipo Ocorrência";
		if (telaCadastro) return "Cadastro de Sub Tipo Ocorrência";
		return "Sub Tipo Ocorrência";
	}, [editando, telaCadastro]);

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValues((current) => ({
			...current,
			usuario: dadosUsuarioRedux.usuario.usuario,
		}));
		setValidator((current) => ({ ...current, nome: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarSubTipoOcorrenciaPorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarSubTipoOcorrencia();
		buscarTipoOcorrencia();
		if (props.idAtual) {
			buscarSubTipoOcorrenciaPorIdModal(props.idAtual);
		}
	}, []);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element === "Uso Comum") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra === "Uso Comum") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	const [listaTipoOcorrencia, setListaTipoOcorrencia] = useState([]);

	const [disable, setDisable] = useState(false);

	const [idAtual, setIdAtual] = useState();

	const [loadingSelectTipoOcorrencia, setLoadingSelectTipoOcorrencia] =
		useState(false);

	const [openCadastroTipoOcorrencia, setOpenCadastroTipoOcorrencia] =
		useState(false);

	const [valuesSelect, setValuesSelect] = useState([]);

	const clearTipoOcorrencia = () => {
		setValuesSelect((current) => ({ ...current, tipoOcorrencia: "" }));
		setValues((current) => ({ ...current, idTipoOcrrencia: null }));
		setValidator((current) => ({ ...current, tipoOcorrencia: "false" }));
	};

	const handleCloseCadastroTipoOcorrencia = (value) => {
		if (idAtual) {
			setOpenCadastroTipoOcorrencia(false);
		} else {
			setLoadingSelectTipoOcorrencia(true);
			buscarTipoOcorrenciaSemLoading();
			setOpenCadastroTipoOcorrencia(false);
		}
	};

	const buscarTipoOcorrencia = async () => {
		setLoading(true);
		await getTipoOcorrencia(dadosUsuarioRedux.token)
			.then((result) => {
				setListaTipoOcorrencia(result.data);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarTipoOcorrenciaSemLoading = async () => {
		await getTipoOcorrencia(dadosUsuarioRedux.token)
			.then((result) => {
				setListaTipoOcorrencia(result.data);
				setLoadingSelectTipoOcorrencia(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					{props.navbar ? (
						<></>
					) : (
						<NavbarV3 title={title} selecionado="SubTipoOcorrencia" />
					)}
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					{props.navbar ? (
						<></>
					) : (
						<NavbarV3 title={title} selecionado="SubTipoOcorrencia" />
					)}
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="idSubTipoOcorrencia"
										nomeClasse1="outer-wrapper-cidade"
										nomeClasse2="table-wrapper-cidade-v2"
										colunas={dadosTabelaRedux.SubTipoOcorrencia}
										dados={dadosTabela}
									/>
									<div className="container-botoes-cliente">
										<div>
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Cadastrar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setTelaCadastro(true);
													setEditando(false);
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-deletar"
												classText="button-texto-cadastrar"
												titulo="Deletar"
												icone="iconeDelete"
												cor="#DC2D2D"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setOpen(true);
														setTextoSucesso("Deletado Com Sucesso");
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
										<div>
											<CustomButtonV2
												classCss="custom-button-user"
												classText="button-texto-user"
												titulo="Obter Usuário"
												cor="#FFFFFF"
												valor={values}
												onClick={() => {
													if (tabelaRedux.usuarioAlteracao) {
														setOpenUsuario(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									{!props.desabilitar ? (
										<div className="indicadores">
											{props.botaoFechar !== false && (
												<div style={{ width: 29, height: 29 }} />
											)}
											<div className="texto-cadastro">
												<p className="indicador-emb">
													{"Dados de Sub Tipo Ocorrência / "}
												</p>
												{editando ? (
													<p className="indicador-emb">
														{"Detalhes de Sub Tipo Ocorrência"}
													</p>
												) : (
													<p className="indicador-emb">
														{"Cadastro de Sub Tipo Ocorrência"}
													</p>
												)}
												<HeaderCadastro texto="" />
											</div>
											{props.botaoFechar !== false && (
												<div className="close-btn">
													<CloseIcon
														onClick={() => {
															setValues({});
															setTelaCadastro(false);
															setEditando(false);
															setTabelaRedux({});
															setValuesSelect({});
														}}
													/>
												</div>
											)}
										</div>
									) : (
										<></>
									)}
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															Sub Tipo Ocorrência:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	nome: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	nome: "true",
																}));
															}}
															placeholder="Ex: Pallet"
															value={values.nome}
															disabled={props.desabilitar}
														/>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												{loadingSelectTipoOcorrencia ? (
													<LoadingBar />
												) : (
													<div className="coluna-emb">
														<div className="principal">
															<p
																className="input-label-emb"
																htmlFor="descricao"
															>
																Tipo Ocorrência:
															</p>
															<SelectEmbarqueV2
																classeCss={250}
																onChange={(e) => {
																	setValuesSelect((current) => ({
																		...current,
																		tipoOcorrencia: e,
																	}));
																	setValues((current) => ({
																		...current,
																		tipoOcorrenciaId: e.id,
																	}));
																	setValidator((current) => ({
																		...current,
																		tipoOcorrencia: "true",
																	}));
																}}
																onClick={(e) => {
																	e.stopPropagation();
																	setDisable(true);
																	setOpenCadastroTipoOcorrencia(true);
																}}
																clearSelection={clearTipoOcorrencia}
																onInfoIconClick={setIdAtual}
																id="idTipoOcorrencia"
																grande={true}
																value={valuesSelect.tipoOcorrencia}
																titulo="Grupo Cliente"
																dadosSelect={listaTipoOcorrencia}
																referenciaId="nome"
																referenciaItem="nome"
															/>
														</div>
														<NewIcon
															onClick={(e) => {
																setOpenCadastroTipoOcorrencia(true);
																setIdAtual(null);
																setDisable(false);
															}}
														/>
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="botoes-subTipoOcorrencia">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
													setTelaCadastro(false);
													setEditando(false);
													setValues({});
													setValuesSelect({});
												}}
											/>
										) : (
											<>
												{!props.desabilitar ? (
													props.botaoCadastrar ? (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.nome !== "" &&
																	validator.nome === "true"
																) {
																	cadastrar();
																	setValues({});
																	setValuesSelect({});
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													) : (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.nome !== "" &&
																	validator.nome === "true"
																) {
																	cadastrar();
																	setValues({});
																	setValuesSelect({});
																	setTelaCadastro(false);
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													)
												) : (
													<></>
												)}
											</>
										)}
										{props.botaoVoltar ? (
											<></>
										) : (
											<CustomButtonV2
												classCss="custom-button-cancelar"
												classText="button-texto-cancelar"
												titulo="Cancelar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setValues({});
													setValuesSelect({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										)}
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarSubTipoOcorrenciaPorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
								<ModalCadastro
									titulo="Cadastro"
									tituloConfirmar="OK"
									cadastroTipoOcorrencia="sim"
									open={openCadastroTipoOcorrencia}
									idAtual={idAtual}
									desabilitar={disable}
									onClose={handleCloseCadastroTipoOcorrencia}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default SubTipoOcorrencia;
